import React, { useEffect, useRef, useState } from 'react';
import { Dithering } from '@paper-design/shaders-react';

/* Subtle animated dithering background for the hero (Cult UI shader, brand-tinted). */
const HeroDither = () => {
  const [reducedMotion, setReducedMotion] = useState(false);
  const wrapRef = useRef(null);
  // The hero sits above the fold, so this starts true — same convention as
  // GHCMeshBg further down the homepage, which drops its shader's speed to
  // 0 once scrolled out of view instead of rendering forever unseen.
  const [active, setActive] = useState(true);

  useEffect(() => {
    setReducedMotion(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => setActive(e.isIntersecting), { rootMargin: '150px' });
    if (wrapRef.current) obs.observe(wrapRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={wrapRef} className="nx-hero-dither" aria-hidden="true">
      <Dithering
        style={{ width: '100%', height: '100%' }}
        colorBack="#00000000"
        colorFront="#0071e3"
        shape="swirl"
        type="4x4"
        size={2}
        speed={reducedMotion ? 0 : active ? 0.35 : 0}
        scale={1.1}
        minPixelRatio={1}
      />
    </div>
  );
};

export default HeroDither;
